<p *ngIf="componentData$ | async as data" [innerHTML]="data.content | safe: 'html'"></p>
